export const getDisplayName = WrappedComponent => WrappedComponent.displayName || WrappedComponent.name || 'Component';
